var map = {
	"./ainola_1.jpg": 125,
	"./ainola_2.jpg": 126,
	"./kyykka_1.jpg": 127,
	"./kyykka_2.png": 128,
	"./kyykka_3.jpg": 129,
	"./kyykka_4.jpg": 130,
	"./puutarha_1.jpeg": 131,
	"./puutarha_2.jpg": 132,
	"./puutarha_3.jpg": 133,
	"./torinranta_1.jpg": 134,
	"./torinranta_2.jpg": 135,
	"./yliopisto1.png": 136,
	"./yliopisto2.jpg": 137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;